
class LoadingModal {

    Id = null;
    _element = null;
    Istance = null;

    constructor(selector) {
        this.Id = selector;
        this._element = document.getElementById(this.Id);
        //this.Istance = bootstrap.Modal.getOrCreateInstance(this._element);
        //this._element.addEventListener('hide.bs.modal', this.hideHandler.bind(this));
        //this._element.addEventListener('show.bs.modal', this.showHandler.bind(this));
        //this._element.addEventListener('shown.bs.modal', this.shownHandler.bind(this));
    }

    HideHandler(event) {
        var currentOpenRequest = this._element.getAttribute('data-openrequests-pending');
        if (currentOpenRequest) {
            currentOpenRequest--;
            if (currentOpenRequest < 0);
            currentOpenRequest = 0
        } else {
            currentOpenRequest = 0
        }
        this._element.setAttribute('data-openrequests-pending', currentOpenRequest);
        if (currentOpenRequest > 0) {
            event.preventDefault();
        }
    }

    ShowHandler(event) {

        var currentOpenRequest = this._element.getAttribute('data-openrequests-pending');
        if (currentOpenRequest) {
            currentOpenRequest++;
        } else {
            currentOpenRequest = 1;
        }
        this._element.setAttribute('data-openrequests-pending', currentOpenRequest);
    }

    shownHandler(event) {
        const firstFocusableElement = this._element.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (firstFocusableElement) {
            firstFocusableElement.focus();
        }
    }


    Build(title, content, idType, btn01_navigate, btn02_navigate) {
        try {

            this._element.querySelector('span.main-loader').classList.remove('d-none');





            this._element.querySelector('.modal-title').innerHTML = title;
            this._element.querySelector('.modal-contenuto').innerHTML = content;

            this._element.querySelector('.modal-button-02').classList.add('d-none');

            this._element.querySelector('.modal-button-01').addEventListener('click', function () { Modal_Hide(); });
            this._element.querySelector('.modal-button-02').addEventListener('click', function () { Modal_Hide(); });

            this.customizeButtons(btn01_navigate, btn02_navigate);
            this.customizeStyle(idType);
            this._element.setAttribute('data-openrequests-pending', 0);

        } catch (e) {
            console.error('[DEBUG] Build', e);
        }
    }

    customizeStyle(idType) {
        if (idType === 1) {
            //Modalità popup "operazione eseguita", un solo pulsante con eventuale navigazione
            this._element.querySelector('.modal-title').classList.add('text-success');
        } else if (idType === 2) {
            // Modalità popup errore, un solo pulsante con eventuale navigazione
            this._element.querySelector('.modal-title').classList.add('text-danger');
        } else if (idType === 3) {
            //Modalità popup domanda "si/no", due pulsanti con navigazione obbligatoria
            this._element.querySelector('.modal-button-02').classList.remove('d-none');

        } else if (idType === 4) {
            //Modalità popup con chiusura automatica
            this._element.querySelector('.modal-button-01').classList.add('d-none');
            this._element.querySelector('.modal-button-01').textContent = 'SI';
            this._element.querySelector('.modal-button-02').textContent = 'NO';
        }


    }

    customizeButtons(btn01_navigate, btn02_navigate) {
        if (btn01_navigate === undefined || btn01_navigate === null) { btn01_navigate = ''; }
        if (btn02_navigate === undefined || btn01_navigate === null) { btn02_navigate = ''; }

        // Imposta il valore predefinito dei pulsanti
        this._element.querySelector('.modal-button-01').textContent = 'OK';
        this._element.querySelector('.modal-button-02').textContent = '';

        if (btn01_navigate === '' && btn02_navigate === '') {
            this._element.querySelector('.modal-footer').classList.add('d-none');
        } else {
            this._element.querySelector('.modal-footer').classList.remove('d-none');
        }
        if (btn01_navigate !== '') {
            this._element.querySelector('.modal-button-01').addEventListener('click', function () {
                window.location.href = '"' + btn01_navigate + '"';
                Modal_Hide();
            });
        }
        if (btn02_navigate !== '') {
            this._element.querySelector('.modal-button-02').addEventListener('click', function () {
                window.location.href = '"' + btn02_navigate + '"';
                Modal_Hide();
            });
        }
    }
}

function Modal_Hide() {
    if (document.getElementById('LoadingModal') !== null) {
        application.ModalManagerIstance.hide(application.LoadingModalIstance.Id);
    } else {
        console.log('[DEBUG] Modal_Hide: "LoadingModal" not exists')
    }

    //$('body').removeClass('modal-open');
    //$('.modal-backdrop').remove();
}
function Modal_ShowWait(Title, Content) {
    if (Title === undefined) { Title = ''; };
    if (Content === undefined) { Content = ''; };
    if (Title === '') { Title = 'Richiesta in corso'; };
    if (Content === '') { Content = 'Attendere prego... Premere <strong>F5</strong> in caso di attesa prolungata'; };  



    application.LoadingModalIstance.Build(Title, Content);
    setTimeout(() => {        
        application.ModalManagerIstance.show(application.LoadingModalIstance.Id);
    }, 20)
    
        

}


function Modal_CKL_Item_Show(SourceId, Title) {
    //  SourceId indica l'ID dell'elemento hidden che contiene il valore della risposta

    Title = Title.trim();
    //Title = CleanHTML(Title, 2);

    if (Title == '') { Title = '&nbsp;' }

    $('.Pyxis_CKL_Item_Editor_Container').not('.show').each(function () {

        $(this).addClass('show');

        var Modal_Title = document.getElementById('Pyxis_CKL_Item_Title');//  Modal_Title contiene l'elemento HTML con il title della modale

        if (Modal_Title != null) {
            Modal_Title.innerHTML = Title;
        }


        var Source_Element = document.getElementById(SourceId); //  Source_Element contiene l'oggetto hidden con il valore corrente della risposta

        if (Source_Element != null) {

            var Source_Value = Source_Element.value;    //  Source_Value contiene il valore della risposta attuale



            var Modal_SourceElement = document.getElementById('cphNavigation_ucpPyxisFormCKLItem_Modal_hydIdCKL');//  Modal_SourceElement contiene l'ID dell'elemento hidden dell'editor HTML con il valore reale

            if (Modal_SourceElement != null) {
                Modal_SourceElement.value = SourceId // Memorizzo nell'editor l'ID di provenienza

                var Modal_CurrentValueElement = document.getElementsByClassName('ql-editor')

                if (Modal_CurrentValueElement != null) {
                    Source_Value = CleanHTML(Source_Value, 1);
                    Modal_CurrentValueElement[0].innerHTML = '';
                    Modal_CurrentValueElement[0].innerHTML = Source_Value;
            }

            }

        }





    });

}

function Modal_CKL_Item_Hide() {

    $('.Pyxis_CKL_Item_Editor_Container.show').each(function () {
        $(this).removeClass('show');

    });

}


function Modal_CKL_Item_Save() {

    var SourceElement_Container = document.getElementById('cphNavigation_ucpPyxisFormCKLItem_Modal_hydIdCKL');  //  SourceElement_Container contiene l'ID dell'elemento hidden con il valore di provenienza

    if (SourceElement_Container !== null) {

        if (SourceElement_Container.value != undefined) {

            var SourceElement = document.getElementById(SourceElement_Container.value);// SourceElement contiene l'elemento hidden di provenienza
            var SourceElement_html = document.getElementById(SourceElement_Container.value+'_html');// SourceElement_html contiene l'elemento div visibile di provenienza

            var NewValue_Element = document.getElementById('cphNavigation_ucpPyxisFormCKLItem_Modal_ucpHTMLEditor_CKL_Item_hydQuillValue'); // NewValue_Element contiene l'elemento hidden con il valore impostato nell'editor

            if (NewValue_Element != null) {

                var NewValue = NewValue_Element.value;  // NewValue contiene il nuvo valore impostato nell'editor
                SourceElement_html.innerHTML = NewValue;    //  Visualizzo il testo html
                NewValue = CleanHTML(NewValue, 2);
                SourceElement.value = NewValue; //  Memorizzo il valore aggiornato dall'editor nell'elemento sorgente
                

            }

        }
        
    }

    Modal_CKL_Item_Hide();

}